import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=a4bd490c&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4bd490c')) {
      api.createRecord('a4bd490c', component.options)
    } else {
      api.reload('a4bd490c', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=a4bd490c&", function () {
      api.rerender('a4bd490c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4H4CWVCAKegFN/JS/pricehelp.vue"
export default component.exports